import React from "react";
import { string, oneOf, number, bool, oneOfType, node } from "prop-types";
import { invariant } from "../utils/invariant";
import { classes } from "../utils/classes";
import forwardRefPropType from "../utils/forward-ref";
import pureFC from "../utils/pureFC";
import { utilityClassName, utilityProps, utilityPropTypes } from "../props/utility";
import { sxClassName, sxProps, sxPropTypes } from "../props/sx";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";

const Input = ({
	type = "text",
	hideInputNumberArrows = true,
	maxLength = 250,
	error,
	className,
	forwardRef,
	utility = { ...utilityProps },
	sx = { ...sxProps },
	spacing = { ...spacingProps },
	...props
}) => {
	invariant(/^(button|reset|submit)$/.test(type), "Use <Button /> component instead of Input");

	return (
		<input
			type={type}
			maxLength={maxLength}
			ref={forwardRef}
			className={classes(
				"field__input",
				`field__${type}`,
				type === "number" && hideInputNumberArrows && "hidden-arrows",
				error && "field--error",
				...utilityClassName(utility),
				...sxClassName(sx),
				...spacingClassName(spacing),
				className,
			)}
			{...props}
		/>
	);
};

Input.propTypes = {
	type: oneOf([
		"email",
		"file",
		"hidden",
		"number",
		"password",
		"range",
		"search",
		"tel",
		"text",
		"url",
	]),
	className: string,
	maxLength: number,
	error: oneOfType([bool, string, node]),
	hideInputNumberArrows: bool,
	forwardRef: forwardRefPropType,
	utility: utilityPropTypes,
	sx: sxPropTypes,
	spacing: spacingPropTypes,
};

export default pureFC(Input);
